import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";
const Main = lazy(
  () => import("../../../components/settings/certificate/signatoryType/main")
);

const SignatoryType = () => {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <Main />
    </Suspense>
  );
};

export default SignatoryType;
